// extracted by mini-css-extract-plugin
export default {"infoIcon":"AgreementTopPanel_infoIcon__7PVQU","topPanel":"AgreementTopPanel_topPanel__Tze8z"};